<p-dialog
  [(visible)]="visivel"
  
  header="Trocar a senha"
  [modal]="true"
  styleClass="p-fluid"
  (onHide)="escondeDialog()"
>
<ng-template pTemplate="content">
    <div class="field">
        Digite seu e-mail cadastrado para receber um e-mail com as instruções para redefinição.
    </div>
    <div class="field">
        <label for="nome">E-mail:</label>
        <input id="nome" pInputText type="text" [(ngModel)]="email" required autofocus>
        <small class="p-error" *ngIf="emailEnviado && !email">E-mail é obrigatório.</small>
    </div>
</ng-template>
<ng-template pTemplate="footer">
    <button
      pButton
      label="Cancelar"
      icon="pi pi-times"
      class="p-button-text"
      (click)="escondeDialog()"
    ></button>
    <button
      pButton
      [loading]="loading"
      label="Enviar senha"
      icon="pi pi-check"
      class="p-button-text bg-red"
      (click)="submit()"
    ></button>
</ng-template>
</p-dialog>
